import { useEffect, useState } from 'react';

/**
 * Debounce a value. Promoted from the identical local copies in the patient
 * list pages (PRD.330 §23.8); those copies are not migrated yet.
 */
export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debounced;
}
